'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PortalCompatContextProvider: function() {
        return PortalCompatContextProvider;
    },
    usePortalCompat: function() {
        return usePortalCompat;
    }
});
var _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
var _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
var PortalCompatContext = _react.createContext(undefined);
var portalCompatContextDefaultValue = function() {
    return function() {
        return undefined;
    };
};
var PortalCompatContextProvider = PortalCompatContext.Provider;
function usePortalCompat() {
    var _React_useContext;
    return (_React_useContext = _react.useContext(PortalCompatContext)) !== null && _React_useContext !== void 0 ? _React_useContext : portalCompatContextDefaultValue;
}
